// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { moonbaseAlpha as _moonbaseAlpha } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the moonbaseAlpha chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 1287
 * Chain Name: Moonbase Alpha
 * Default Block Explorer: https://moonbase.moonscan.io
 * Default RPC URL: https://rpc.api.moonbase.moonbeam.network
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { moonbaseAlpha } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: moonbaseAlpha,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const moonbaseAlpha = createCommon({
	..._moonbaseAlpha,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
